<ng-container *cignaResponsive="let screen">
  <div [ngClass]="{ 'col-12': consumerId === 'chcp' }">
    <h5 class="mb-3" *ngIf="consumerId === 'chcp'">
      {{ 'drugNameSearch.header.hcp' | translate }}
    </h5>
    <h5 class="srh-drug mb-3" *ngIf="consumerId !== 'chcp'">
      {{ 'drugNameSearch.search_method' | translate }}
    </h5>
  </div>
  <div *ngIf="otherInfo?.migrated">
    <hr />
    <div class="row">
      <div class="col-sm select-border" *ngIf="otherInfo?.createdDate">
        <div class="row justify-content-center">
          <small
            ><b>{{ 'dates.date_created' | translate }}</b></small
          >
        </div>
        <div class="row justify-content-center">
          <small>{{ otherInfo?.createdDate | date : 'MM/dd/yyyy' }}</small>
        </div>
      </div>
      <div class="col-sm select-border" *ngIf="otherInfo?.dateUpdated">
        <div class="row justify-content-center">
          <small
            ><b>{{ 'dates.last_update' | translate }}</b></small
          >
        </div>
        <div class="row justify-content-center">
          <small>{{ otherInfo?.dateUpdated | date : 'MM/dd/yyyy' }}</small>
        </div>
      </div>
      <div class="col-sm" *ngIf="otherInfo?.scheduledUpdate">
        <div class="row justify-content-center">
          <small
            ><b>{{ 'dates.scheduled_update' | translate }}</b></small
          >
        </div>
        <div class="row justify-content-center">
          <small>{{ otherInfo?.scheduledUpdate | date : 'MM/dd/yyyy' }}</small>
        </div>
      </div>
    </div>
    <hr />
  </div>
  <div *ngIf="otherInfo.migrated !== undefined && !otherInfo?.migrated">
    <hr />
    <div class="row">
      <div class="col-sm select-border">
        <div class="row justify-content-center">
          <small
            ><b>{{ 'dates.date_created' | translate }}</b></small
          >
        </div>
        <div class="row justify-content-center">
          <small>{{
            'dates.date_created_value' | translate : { date: 'MM/dd/yyyy' }
          }}</small>
        </div>
      </div>
      <div class="col-sm select-border">
        <div class="row justify-content-center">
          <small
            ><b>{{ 'dates.last_update' | translate }}</b></small
          >
        </div>
        <div class="row justify-content-center">
          <small>{{
            'dates.last_update_value' | translate : { date: 'MM/dd/yyyy' }
          }}</small>
        </div>
      </div>
      <div class="col-sm">
        <div class="row justify-content-center">
          <small
            ><b>{{ 'dates.scheduled_update' | translate }}</b></small
          >
        </div>
        <div class="row justify-content-center">
          <small>{{
            'dates.scheduled_update_value' | translate : { date: 'MM/dd/yyyy' }
          }}</small>
        </div>
      </div>
    </div>
    <hr />
  </div>
  <div class="modal-body pt-0 over-flow">
    <div class="row position-relative height over-flow">
      <strong class="floating-or right-50">
        {{ 'drugNameSearch.or' | translate }}
      </strong>
      <div class="col-sm-6 drug-search field">
        <div class="row">
          <div class="col-sm-12 mt-4 rx-res">
            {{ 'drugNameSearch.enter_prescription.cigna' | translate }}
          </div>
        </div>
        <form (submit)="selectDrug(searchedDrugName.trim())">
          <div class="row">
            <div class="col-sm-12 mt-2">
              <div class="input-button" (focusout)="searchDropdownFocusOut()">
                <input
                  type="text"
                  name="gl-lookingForText"
                  id="gl-lookingForText"
                  autocomplete="off"
                  [(ngModel)]="searchedDrugName"
                  class="input-shadow"
                  (ngModelChange)="getTypeaHead($event)"
                />
                <div
                  class="table-responsive pr-2 searchDropdown"
                  [ngClass]="
                    consumerId === 'chcp' ? 'mt-3' : 'table-width mt-27'
                  "
                  *ngIf="
                    showSearchDropdown &&
                    (!typeaHead?.loaded ||
                      (typeaHead?.data && typeaHead?.data?.length))
                  "
                  (mouseenter)="focusOnOff(true)"
                  (mouseleave)="focusOnOff(false)"
                >
                  <ng-container *cignaWaitToLoad="typeaHead; let list">
                    <table class="table table-height" *ngIf="list.length > 0">
                      <tbody>
                        <tr class="suggested-drug">
                          <td>
                            {{ 'drugNameSearch.drug_names' | translate }}
                          </td>
                        </tr>
                        <tr
                          *ngFor="let item of list"
                          (click)="selectDrug(item.drugName.trim())"
                          class="clickable-search"
                        >
                          <td>
                            <b>{{ item.drugName }}</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-sm-12 mt-2">
            <div class="button-container">
              <button
                class="btn-method"
                cignaButton="secondary"
                (click)="selectDrug(searchedDrugName.trim())"
              >
                {{ 'drugNameSearch.search' | translate }}
              </button>
              <button
                class="btn-method btn-reset"
                cignaButton="primary"
                (click)="resetBtnClick()"
              >
                {{ 'drugNameSearch.reset' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 no-padding clickable" (click)="drugsListClick('A')">
        <div class="row">
          <div class="col-sm-12 drug-search view-all">
            <div class="column-centered">
              <div class="row">
                <div
                  class="pl-0"
                  [ngClass]="
                    screen.isSmallerOrEqual('sm') ? 'col-6' : 'col-sm-12'
                  "
                >
                  <div class="d-table pb-2 w-100">
                    <div class="drug-centered">
                      <div class="drug-list-icon"></div>
                    </div>
                  </div>
                </div>
                <div
                  [ngClass]="
                    screen.isSmallerOrEqual('sm')
                      ? 'view-az-res col-6'
                      : 'p-0 col-sm-12'
                  "
                >
                  <div class="d-table pb-2">
                    <div class="drug-centered">
                      {{ 'drugNameSearch.view_complete.cigna' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="emptyDrugStr">
    <p
      *ngIf="consumerId === 'chcp'; else nonChcp"
      class="rx-cnt-error"
      [innerHTML]="
        'drugNameSearch.error_messages.hcp.required_drug_name.message'
          | translate
      "
    ></p>
    <ng-template #nonChcp>
      <p
        class="rx-cnt-error"
        [innerHTML]="
          'drugNameSearch.error_messages.cigna.required_drug_name.message'
            | translate
        "
      ></p>
    </ng-template>
  </ng-container>
</ng-container>
